import { useEffect, useState } from "react";
import Loader from "@element/Loader/Loader";
import { apiRequest } from "@utils/service";
import Default from "@layout/Default/Default";

interface Product {
  product_id: string;
  product_img: string;
  product_name: string;
  product_author: string;
  product_price: string;
  product_disc_price: string;
}
const BookNPendrive = () => {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState<Product[]>([]);

  useEffect(() => {
    setLoading(true);
    apiRequest("products", {}, "get")
      .then((resp) => {
        if (resp.success === "true") {
          setProducts(resp.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Default>
      {loading && <Loader />}
      <div className="d-flex justify-content-center">
        <div className="card">
          <div className="card-header">
            <h3>Book & Pendrive</h3>
          </div>
          <div className="card-body">
            <div className="row g-4">
              {products.map((product) => (
                <div key={product.product_id} className="col-6">
                  <div className="d-flex gap-2 border p-2">
                    <div className="d-flex justify-content-center align-items-center border p-2">
                      <img
                        src={product.product_img}
                        alt={product.product_name}
                        style={{ height: 100, width: 100 }}
                      />
                    </div>
                    <div className="w-100">
                      <h6 className="">{product.product_name}</h6>
                      <div className="d-flex flex-column mt-2 justify-content-between">
                        <small>{product.product_author}</small>
                        <small>ID: {product.product_id}</small>
                        <h5 className="mt-2 mb-0">
                          <del className="text-muted me-2">
                            {Intl.NumberFormat("en-IN", {
                              currency: "INR",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                              style: "currency",
                            }).format(Number(product.product_disc_price))}
                          </del>
                          {Intl.NumberFormat("en-IN", {
                            currency: "INR",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                            style: "currency",
                          }).format(Number(product.product_disc_price))}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Default>
  );
};

export default BookNPendrive;
